export enum AccountStatus {
  Active = "",
  Churned = "churned",
  Churned_TMS = "churned_tms",
}
